import Plus from '#atoms/Icon/icons/Plus';

interface PlusButtonProps {
  text: string;
  onClick: () => void;
  style?: React.CSSProperties;
}
export const PlusButton = ({ text, onClick, style }: PlusButtonProps) => {
  return (
    <div
      onClick={onClick}
      className="mt-20 w-full h-[54px] px-10 bg-[#2e2a3a] rounded-lg justify-center items-center gap-4 inline-flex"
      style={style}
    >
      <Plus />
      <div className="text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
        {text}
      </div>
    </div>
  );
};
